import { useCallback, useEffect, useState } from 'react';
import mixpanel from 'mixpanel-browser';
import './assets/styles/main.scss';
import Header from './components/header/Header';
import Hero from './components/hero/Hero';
import Schedule from './components/schedule/Schedule';

function App() {
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const [deviceId, setDeviceId] = useState('');
  const getMixPanelDeviceId = useCallback(() => {
    const cookies = document.cookie;
    const cookieArray = cookies.split(';');
    cookieArray.forEach((cookie) => {
      // Trim any whitespace and split the cookie into name-value pairs
      const [name, value] = cookie.trim().split('=');
      if (name.startsWith('mp_')) {
        const jsonValue = JSON.parse(decodeURIComponent(value));
        setDeviceId(jsonValue.$device_id);
      }
    });
    return deviceId;
  }, [deviceId]);

  useEffect(() => {
    if (process.env.REACT_APP_CONTENT_ENV === 'prod') {
      // INIT:
      try {
        mixpanel.init(process.env.REACT_APP_PUBLIC_MIXPANEL_CLIENT_SIDE_TOKEN!, {
          debug: false,
        });
      } catch (err) {
        console.log(err);
      }

      try {
        // get and set deviceId
        getMixPanelDeviceId();
      } catch (err) {
        console.log(err);
      }
    }
  }, [getMixPanelDeviceId]);

  return (
    <section className="app">
      <Header />
      <Hero timezone={timezone} />
      <Schedule />
    </section>
  );
}

export default App;
